import axios from "../../../config/axiosConfig";

/**
 * GET /api/equipos-modem/num-sim/:num_sim/sensores
 * @param {string|number} numSim
 * @returns {Promise<AxiosResponse<{ ID_A:number, num_sim:string, sensores: Record<string, boolean> }>>}
 */
export const getModemSensoresByNumSim = (numSim) => {
  const ns = encodeURIComponent(String(numSim ?? ""));
  return axios.get(`/api/equipos-modem/num-sim/${ns}/sensores`);
};

/**
 * Helper: normaliza la respuesta a un objeto de sensores (todos booleanos)
 * @param {any} respData
 * @returns {{ sensores: Record<string, boolean>, idA?: number, num_sim?: string }}
 */
export const normalizeSensores = (respData) => {
  const raw = respData?.sensores || {};
  const keys = [
    "buzer",
    "ibutton",
    "corte_motor",
    "temperatura",
    "acelerometro",
    "boton_panico",
    "sensor_puerta",
  ];
  const sensores = Object.fromEntries(keys.map((k) => [k, Boolean(raw?.[k])]))
  return { sensores, idA: respData?.ID_A, num_sim: respData?.num_sim };
};
